import "./HomeHero.scss";
import { motion, useScroll, useTransform } from "framer-motion";

function Hero({ CLOUDFRONT_URL }) {
  const { scrollYProgress } = useScroll();
  const backgroundColor = useTransform(
    scrollYProgress,
    [0, 0.075, 0.15],
    ["rgba(0, 0, 0, 0)", "rgba(0, 0, 0, 0.5)", "rgba(0, 0, 0, 1)"]
  );

  const orangeSatelliteImageSource = `${CLOUDFRONT_URL}/hero-images/orange/mb/orange-satellite.jpg 100w,
${CLOUDFRONT_URL}/hero-images/orange/lmb/orange-satellite.jpg 130w,
${CLOUDFRONT_URL}/hero-images/orange/stb/orange-satellite.jpg 160w,
${CLOUDFRONT_URL}/hero-images/orange/tb/orange-satellite.jpg 200w,
${CLOUDFRONT_URL}/hero-images/orange/sm/orange-satellite.jpg 260w,
${CLOUDFRONT_URL}/hero-images/orange/md/orange-satellite.jpg 300w,
${CLOUDFRONT_URL}/hero-images/orange/lg/orange-satellite.jpg 350w`;

  const orangeBlurImageSource = `${CLOUDFRONT_URL}/hero-images/orange/mb/orange-blur.png 130w,
${CLOUDFRONT_URL}/hero-images/orange/lmb/orange-blur.png 160w,
${CLOUDFRONT_URL}/hero-images/orange/stb/orange-blur.png 190w,
${CLOUDFRONT_URL}/hero-images/orange/tb/orange-blur.png 230w,
${CLOUDFRONT_URL}/hero-images/orange/sm/orange-blur.png 320w,
${CLOUDFRONT_URL}/hero-images/orange/md/orange-blur.png 360w,
${CLOUDFRONT_URL}/hero-images/orange/lg/orange-blur.png 400w`;

  const orangeBitmapImageSource = `${CLOUDFRONT_URL}/hero-images/orange/mb/orange-bitmap.png 130w,
${CLOUDFRONT_URL}/hero-images/orange/lmb/orange-bitmap.png 160w,
${CLOUDFRONT_URL}/hero-images/orange/stb/orange-bitmap.png 190w,
${CLOUDFRONT_URL}/hero-images/orange/tb/orange-bitmap.png 230w,
${CLOUDFRONT_URL}/hero-images/orange/sm/orange-bitmap.png 320w,
${CLOUDFRONT_URL}/hero-images/orange/md/orange-bitmap.png 360w,
${CLOUDFRONT_URL}/hero-images/orange/lg/orange-bitmap.png 400w`;

  return (
    <div className="hero">
      <motion.div
        className="hero__overlay"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor,
        }}
      />
      <div className="hero__content">
        <div className="hero__grid"></div>
        <div className="hero__text">earth, understood.</div>
        <img
          className="hero__image hero__image hero__image--large hero__image--blur"
          srcSet={orangeBlurImageSource}
          sizes="(max-width: 424px) 130px,
       (max-width: 575px) 160px,
       (max-width: 767px) 190px,
       (max-width: 1023px) 230px,
       (max-width: 1439px) 320px,
       (max-width: 1919px) 360px,
       400px"
          alt="orange blur satellite"
        />
        <img
          className="hero__image hero__image hero__image--large hero__image--bitmap"
          srcSet={orangeBitmapImageSource}
          sizes="(max-width: 424px) 130px,
       (max-width: 575px) 160px,
       (max-width: 767px) 190px,
       (max-width: 1023px) 230px,
       (max-width: 1439px) 320px,
       (max-width: 1919px) 360px,
       400px"
          alt="orange bitmap satellite"
        />
        <img
          className="hero__image hero__image--satellite"
          srcSet={orangeSatelliteImageSource}
          sizes="(max-width: 424px) 100px,
       (max-width: 575px) 130px,
       (max-width: 767px) 160px,
       (max-width: 1023px) 200px,
       (max-width: 1439px) 260px,
       (max-width: 1919px) 300px,
       350px"
          alt="orange satellite"
        />
      </div>
    </div>
  );
}

export default Hero;
